import isString from "@gqlapp/base/utils/isString";

/**
 * Frame
 * @type {({icon: *})[]}
 */
export const Frame = [
	{ frame: 'frame0', font: "0" },
	{ frame: 'frame1', font: "0" },
	{ frame: 'frame2', font: "1" },
	{ frame: 'frame3', font: "2" },
	{ frame: 'frame4', font: "3" },
	{ frame: 'frame5', font: "4" },
	{ frame: 'frame6', font: "5" },
	{ frame: 'frame7', font: "1" },
	{ frame: 'frame8', font: "2" },
	{ frame: 'frame9', font: "3" },
	{ frame: 'frame10', font: "4" },
	{ frame: 'frame11', font: "5" },
	{ frame: 'frame12', font: "1" },
	{ frame: 'frame13', font: "2" },
	{ frame: 'frame14', font: "3" },
	{ frame: 'frame15', font: "4" },
	{ frame: 'frame16', font: "5" },
	{ frame: 'frame17', font: "0" },
	{ frame: 'frame18', font: "1" },
	{ frame: 'frame19', font: "2" },
	{ frame: 'frame20', font: "3" },
	{ frame: 'frame21', font: "3" },
	{ frame: 'frame22', font: "3" },
	{ frame: 'frame23', font: "3" },
	{ frame: 'frame24', font: "3" },
	{ frame: 'circle', font: "0", isCircle: true }
]

export default function getStyle({ style: $frameStyle }){
	let style = 'frame0';
	
	try{
		if(isString($frameStyle) && !Object.keys(Frame).includes($frameStyle)){
			style  = $frameStyle || style;
		}else {
			// @ts-ignore
			style  = Frame[$frameStyle].frame || style;
		}
	}catch (e){}
	
	return style;
}